import React, { useState, useEffect } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import api from '../../../services/api';

const FAQPreview = ({ isAdminPreview = true }) => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openIndex, setOpenIndex] = useState(0);

  const fetchData = async () => {
    try {
      const res = await api.get('/business/faq/');
      setFaqs(res.data || []);
    } catch (err) {
      console.error('Error fetching FAQ preview:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    if (isAdminPreview) {
      const interval = setInterval(fetchData, 2000);
      return () => clearInterval(interval);
    }
  }, [isAdminPreview]);

  if (loading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <div style={{
          width: '2rem', height: '2rem',
          border: '3px solid rgba(255,255,255,0.1)',
          borderTopColor: '#6366f1',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto'
        }} />
      </div>
    );
  }

  if (!faqs.length) {
    return (
      <div style={{
        padding: '2rem',
        textAlign: 'center',
        color: 'rgba(255,255,255,0.5)',
        backgroundColor: '#0f172a',
        minHeight: '200px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        No FAQs added yet.
      </div>
    );
  }

  return (
    <div style={{ padding: '1.5rem', backgroundColor: '#0f172a', minHeight: '200px' }}>
      <h2 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#fff', textAlign: 'center', marginBottom: '1.5rem' }}>
        Frequently Asked Questions
      </h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', maxWidth: '600px', margin: '0 auto' }}>
        {faqs.slice(0, 5).map((faq, index) => (
          <div
            key={faq.id || index}
            style={{
              backgroundColor: 'rgba(255,255,255,0.05)',
              borderRadius: '0.75rem',
              overflow: 'hidden',
              border: openIndex === index ? '1px solid #6366f1' : '1px solid transparent'
            }}
          >
            <button
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
              style={{
                width: '100%',
                padding: '1rem',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                textAlign: 'left'
              }}
            >
              <span style={{ color: '#fff', fontWeight: '500', fontSize: '0.875rem' }}>
                {faq.question}
              </span>
              {openIndex === index ? (
                <ChevronUp size={16} style={{ color: '#6366f1' }} />
              ) : (
                <ChevronDown size={16} style={{ color: 'rgba(255,255,255,0.5)' }} />
              )}
            </button>
            {openIndex === index && (
              <div style={{
                padding: '0 1rem 1rem',
                color: 'rgba(255,255,255,0.7)',
                fontSize: '0.8rem',
                lineHeight: '1.6'
              }}>
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQPreview;
